import styled from "styled-components";

export const StyledPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledPreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
